const MicroscopySDK = require('./microscopy-sdk-min');
module.exports = MicroscopySDK;
